import React from 'react';
import VisuallyHidden from '@atlaskit/visually-hidden';
import Content from '../shared/content';
import useButtonBase from '../shared/use-button-base';
/**
 * __Use icon button__
 *
 * A React hook that accepts a set of icon Button props,
 * and processes them to return consistent base props for usage
 * across IconButton and LinkIconButton variants.
 *
 * @private
 */
var useIconButton = function useIconButton(_ref) {
  var analyticsContext = _ref.analyticsContext,
    appearance = _ref.appearance,
    autoFocus = _ref.autoFocus,
    buttonType = _ref.buttonType,
    Icon = _ref.icon,
    interactionName = _ref.interactionName,
    isDisabled = _ref.isDisabled,
    isSelected = _ref.isSelected,
    label = _ref.label,
    onClick = _ref.onClick,
    onMouseDownCapture = _ref.onMouseDownCapture,
    onMouseUpCapture = _ref.onMouseUpCapture,
    onKeyDownCapture = _ref.onKeyDownCapture,
    onKeyUpCapture = _ref.onKeyUpCapture,
    onTouchStartCapture = _ref.onTouchStartCapture,
    onTouchEndCapture = _ref.onTouchEndCapture,
    onPointerDownCapture = _ref.onPointerDownCapture,
    onPointerUpCapture = _ref.onPointerUpCapture,
    onClickCapture = _ref.onClickCapture,
    overlay = _ref.overlay,
    ref = _ref.ref,
    shape = _ref.shape,
    shouldFitContainer = _ref.shouldFitContainer,
    spacing = _ref.spacing,
    UNSAFE_size = _ref.UNSAFE_size;
  var hasOverlay = Boolean(overlay);
  var isCircle = shape === 'circle';
  var baseProps = useButtonBase({
    analyticsContext: analyticsContext,
    appearance: appearance,
    autoFocus: autoFocus,
    buttonType: buttonType,
    children: /*#__PURE__*/React.createElement(Content, {
      type: "icon",
      hasOverlay: hasOverlay
    }, /*#__PURE__*/React.createElement(Icon, {
      label: "",
      size: UNSAFE_size
    }), /*#__PURE__*/React.createElement(VisuallyHidden, null, label)),
    interactionName: interactionName,
    isDisabled: isDisabled,
    isSelected: isSelected,
    isIconButton: true,
    isCircle: isCircle,
    onClick: onClick,
    onMouseDownCapture: onMouseDownCapture,
    onMouseUpCapture: onMouseUpCapture,
    onKeyDownCapture: onKeyDownCapture,
    onKeyUpCapture: onKeyUpCapture,
    onTouchStartCapture: onTouchStartCapture,
    onTouchEndCapture: onTouchEndCapture,
    onPointerDownCapture: onPointerDownCapture,
    onPointerUpCapture: onPointerUpCapture,
    onClickCapture: onClickCapture,
    overlay: overlay,
    ref: ref,
    shouldFitContainer: shouldFitContainer,
    spacing: spacing
  });
  return baseProps;
};
export default useIconButton;